var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import cx from "clsx";
import { contructItemUrl } from "./helpers";
export var ItemImage = function (_a) {
    var className = _a.className, label = _a.label, url = _a.url, urlType = _a.urlType, image = _a.image, isOnlyChild = _a.isOnlyChild;
    var isLink = url && url.length;
    var baseClass = "block text-text-primary";
    var Wrapper = isLink ? "a" : "div";
    var wrapperProps = {
        href: Wrapper === "a" ? contructItemUrl(url, urlType) : undefined,
        className: cx(className, baseClass),
    };
    var imageProps = {
        src: image === null || image === void 0 ? void 0 : image.url,
        alt: label && label.length ? label : (image === null || image === void 0 ? void 0 : image.alt) || "",
        className: cx("max-h-37 md:max-h-38", {
            "mx-auto pb-2": isOnlyChild,
            "hover:opacity-75 transition-opacity duration-200": isLink,
        }),
    };
    var imageAlt = imageProps.alt, restImageProps = __rest(imageProps, ["alt"]);
    return (React.createElement(Wrapper, __assign({}, wrapperProps, { "data-testid": "item-image" }),
        React.createElement("img", __assign({ alt: imageAlt }, restImageProps, { loading: "lazy" }))));
};
//# sourceMappingURL=ItemImage.js.map